/* eslint-disable react-hooks/exhaustive-deps */
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  MenuItem,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Avatar,
  Box,
} from "@mui/material";
import {
  Card,
  Table,
  Stack,
  Paper,
  Popover,
  TableRow,
  TableBody,
  TableCell,
  Container,
  IconButton,
  TableContainer,
  TablePagination,
} from "@mui/material";
import moment from "moment";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import Iconify from "../../../../components/iconify";
import Chip from "@mui/material/Chip";
import { useNavigate } from "react-router-dom";
import { DELETE, GET } from "../../../../config/https";
import APIS from "../../../../config/api";
import TableHeader from "./table-header";
import TableToolbar from "./table-toolbar";
import Color from "../../../../theme/color";
import FullScreenLoader from "../../../../components/full-screen-loader";
import { Icon } from "@iconify/react";
import { GetLocalStorage } from "../../../../utils/local-storage";
import { usePersistentState } from "../../../../contexts/global-context";
import { marginBottomSize } from "../../../../utils/constant";
import toast from "react-hot-toast";

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "couponCode", label: "Coupon Code", alignRight: false },
  { id: "couponDiscount", label: "Coupon Discount", alignRight: false },
  { id: "couponValue", label: "Coupon Value ", alignRight: false },
  { id: "eventName", label: "Event Name", alignRight: false },
  { id: "ticketType", label: "Ticket Type", alignRight: false },
  { id: "expiryDate", label: "Expiry date", alignRight: false },
  { id: "action", label: "Action", alignRight: false },
];

// ----------------------------------------------------------------------

export default function Coupons() {
  const [state]: any = usePersistentState();
  const [open, setOpen] = useState(null);
  const [newOpen, setNewOpen] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [order, setOrder] = useState("asc");
  const [eventList, setCategoryList] = useState([]);
  const [newId, setNewId] = useState(null);
  const [data, setData] = useState();
  const [orderBy, setOrderBy] = useState("name");
  const [isDescending, setIsDescending] = useState(false);
  const [sortProperty, setSortProperty] = useState("expiredOn");
  const [filterName, setFilterName] = useState("");
  const [couponList, setCouponList] = useState<any>([]);
  const [filterEvent, setFilterEvent] = useState<any>([]);
  const [pagination, setPagination] = useState<any>();
  const filterEventId = filterEvent?.id;
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const [eventDataLoader, setEventDataLoader] = useState(false);
  const navigate = useNavigate();
  let userData = GetLocalStorage("loginData");
  const [organizers, setOrganizers] = useState<any>([]);
  const [selectedOrganizers] = useState({
    value: "",
    label: "",
  });
  const [organizerId, setOrganizerId] = useState({
    value: "",
    label: "",
  });
  const [searchOrganizerData, setSearchOrganizerData] = useState({
    value: "",
    label: "",
  });
  const [loginInfo, setLoginInfo] = useState<any>({});
  useEffect(() => {
    let tempData = GetLocalStorage("loginData");
    setLoginInfo(tempData);
  }, [state.users]);

  const userRole = loginInfo.roles;

  useEffect(() => {
    let loggedInUser = GetLocalStorage("loginData");
    setOrganizerId({
      value: loggedInUser.id,
      label: loggedInUser.companyName,
    });
    getAllUsers();
    GetEventDropdown();
  }, []);

  useEffect(() => {
    GetCouponList();
  }, [
    pageNumber,
    rowsPerPage,
    filterEventId,
    selectedOrganizers,
    userRole,
    organizerId,
    searchOrganizerData,
    isDescending,
    sortProperty,
  ]);

  useEffect(() => {
    const delay = setTimeout(() => {
      GetCouponList();
    }, 1100);
    return () => clearTimeout(delay);
  }, [filterName]);

  const getAllUsers = async () => {
    await GET(APIS.GET_ALL_USER + `?PageSize=10000`)
      .then((res: any) => {
        if (res?.isSuccess) {
          const org = res?.result
            ?.filter((x: any) => x?.companyName)
            .map((x: any) => ({
              value: x.id,
              label: x.companyName,
            }));
          setOrganizers(org);
        }
      })
      .catch(() => {
        console.log("error");
      });
  };

  const GetCouponList = async () => {
    const eventId = filterEventId || "";
    if (userRole?.name === "Host") {
      setEventDataLoader(true);
      if (organizerId?.value) {
        await GET(
          APIS.GET_ALL_COUPON +
            "?SearchValue=" +
            filterName +
            "&OrganizerId=" +
            organizerId?.value +
            "&EventId=" +
            eventId +
            "&PageNumber=" +
            pageNumber +
            "&PageSize=" +
            rowsPerPage +
            "&IsDescending=" +
            isDescending +
            "&SortProperty=" +
            sortProperty
        )
          .then((res: any) => {
            setPagination(res);
            if (res?.isSuccess) {
              setCouponList(res.result);
            } else {
            }
          })
          .catch((error) => {})
          .finally(() => {
            setEventDataLoader(false);
          });
      }
    }

    if (userRole?.name === "Admin") {
      setEventDataLoader(true);
      await GET(
        APIS.GET_ALL_COUPON +
          "?SearchValue=" +
          filterName +
          "&OrganizerId=" +
          searchOrganizerData?.value +
          "&EventId=" +
          eventId +
          "&PageNumber=" +
          pageNumber +
          "&PageSize=" +
          rowsPerPage +
          "&IsDescending=" +
          isDescending +
          "&SortProperty=" +
          sortProperty
      )
        .then((res: any) => {
          setPagination(res);
          if (res?.isSuccess) {
            setCouponList(res.result);
          } else {
          }
        })
        .catch((error) => {})
        .finally(() => {
          setEventDataLoader(false);
        });
    }
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };
  const EventOrganizerId = selectedOrganizers?.value;
  const getOrganizerId = () => {
    if (EventOrganizerId) {
      return EventOrganizerId;
    }
    if (!EventOrganizerId && userData?.roles?.id === 1) {
      return "";
    }
    if (!EventOrganizerId && userData?.roles?.id === 2) {
      return userData?.id;
    }
  };
  const GetEventDropdown = async () => {
    let organizerId = await getOrganizerId();
    await GET(APIS.GET_ALL_EVENTS + "?OrganizerId=" + organizerId)
      .then((res: any) => {
        if (res?.isSuccess) {
          setCategoryList(res.result);
        } else {
          console.log("error");
        }
      })
      .catch((error) => {})
      .finally(() => {});
  };

  const handleClickOpen = () => {
    setNewOpen(true);
  };

  const handleClose = () => {
    setNewOpen(false);
    handleCloseMenu();
  };

  const DeleteCoupon = async () => {
    setLoader(true);
    try {
      const res: any = await DELETE(APIS.DELETE_COUPON + "/" + newId);
      if (res?.isSuccess) {
        toast.success("Coupon has been deleted successfully");
      } else {
        toast.error("Failed to delete event.Please try again later.");
      }
    } catch (error) {
      toast.error("Failed to delete event.Please try again later.");
      console.error("An error occurred while deleting the coupon:", error);
    } finally {
      GetCouponList();
      handleClose();
      handleCloseMenu();
      setLoader(false);
    }
  };

  const handleOnChange = (newValue: any) => {
    setFilterEvent(newValue);
  };

  const handleRequestSort = (event: any, property: any) => {
    let mappedProperty = property;
    if (property === "couponCode") {
      mappedProperty = "couponCode";
    } else if (property === "couponDiscount") {
      mappedProperty = "discountTypeId";
    } else if (property === "couponValue") {
      mappedProperty = "amount";
    } else if (property === "expiryDate") {
      mappedProperty = "expiredOn";
    }
    setSortProperty(mappedProperty);
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setIsDescending(order === "asc" ? true : false);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setPageNumber(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setPageNumber(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event: any) => {
    setPageNumber(0);
    setFilterName(event.target.value);
  };
  const handleFilterByOrganizer = (event: any, newValue: any) => {
    if (newValue === null) {
      setSearchOrganizerData({ value: "", label: "" });
    } else {
      setSearchOrganizerData(newValue);
    }
  };

  const isNotFound = (!couponList.length && !!filterName) || !couponList.length;

  return (
    <>
      <Helmet>
        <title> Coupon | EventPrix </title>
      </Helmet>

      <Container maxWidth={"xl"} style={{ marginBottom: marginBottomSize }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Icon
              width="30"
              height="30"
              style={{ marginRight: 5 }}
              icon="tdesign:coupon"
            />
            <Typography variant="h4">Coupons</Typography>
          </Box>
        </Stack>

        <Card>
          <TableToolbar
            value={searchOrganizerData}
            filterName={filterName}
            placeholder={"Search... "}
            onFilterName={handleFilterByName}
            category={eventList}
            onChange={(newValue: any) => {
              handleOnChange(newValue);
            }}
            loggedInUser={organizerId}
            options={organizers}
            onOrganizerChange={handleFilterByOrganizer}
          />
          <TableContainer
            sx={{ minWidth: 300, minHeight: 300, overflow: "auto" }}
          >
            <Table>
              <TableHeader
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={couponList.length}
                onRequestSort={handleRequestSort}
                sortableColumns={[
                  "couponDiscount",
                  "couponCode",
                  "expiryDate",
                  "couponValue",
                ]}
              />
              <FullScreenLoader open={loader} />
              <FullScreenLoader open={eventDataLoader} />
              <TableBody>
                {couponList?.map((coupon: any, index: any) => {
                  const {
                    id,
                    amount,
                    couponCode,
                    expiredOn,
                    ticketTypes,
                    event,
                    percentage,
                    discountTypeId,
                  } = coupon;
                  // let final = ticketTypes?.filter(function (element: any) {
                  //   return element !== null;
                  // });
                  return (
                    <TableRow key={index}>
                      <TableCell align="center">
                        <Typography variant="subtitle2" noWrap>
                          {couponCode}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        {discountTypeId === 1
                          ? " Fix Cart Discount"
                          : "Percentage Discount"}
                      </TableCell>
                      <TableCell align="center">
                        {discountTypeId === 1 ? "$" + amount : percentage + "%"}
                      </TableCell>
                      <TableCell align="center">{event?.title}</TableCell>
                      <TableCell align="center">
                        <Stack
                          spacing={1}
                          direction="row"
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            alignItems: "center",
                            maxWidth: "100%",
                          }}
                        >
                          {ticketTypes?.map((item: any) => {
                            return (
                              <Chip
                                style={{ margin: "5px" }}
                                label={item?.ticketType}
                              />
                            );
                          })}
                        </Stack>
                      </TableCell>
                      <TableCell align="center">
                        {moment(expiredOn).format("MMM DD, YYYY - h:mm A")}
                      </TableCell>
                      <TableCell align="center">
                        <IconButton
                          size="large"
                          color="inherit"
                          onClick={(event: any) => {
                            setNewId(id);
                            setOpen(event.currentTarget);
                            setData(coupon);
                          }}
                        >
                          <Iconify icon={"eva:more-vertical-fill"} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
              {isNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: "center",
                          height: "160px",
                          alignItems: "center",
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <Typography variant="h5" paragraph>
                          No Data found
                        </Typography>
                        {filterName ? (
                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete
                            words.
                          </Typography>
                        ) : (
                          ""
                        )}
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={pagination?.totalRecords ?? 0}
            rowsPerPage={rowsPerPage}
            page={pageNumber}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            style={{ overflow: "auto" }}
          />
        </Card>
      </Container>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 200,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem
          onClick={() => {
            navigate(`/dashboard/coupons/${newId}/edit`, {
              state: {
                couponId: newId,
                data: data,
                isEditable: true,
              },
              replace: true,
            });
          }}
        >
          <Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem sx={{ color: "error.main" }} onClick={handleClickOpen}>
          <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
        <Dialog
          open={newOpen}
          onClose={handleClose}
          aria-labelledby="delete-dialog-title"
        >
          <DialogContent>
            <Box
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Avatar
                sx={{ backgroundColor: Color.primary, width: 60, height: 60 }}
              >
                <ReportProblemOutlinedIcon sx={{ height: 30, width: "60%" }} />
              </Avatar>
            </Box>
            <Typography sx={{ marginTop: 2 }}>
              {" "}
              Are you sure you want to delete?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button style={{ color: "black" }} onClick={handleClose}>
              Cancel
            </Button>
            <Button
              onClick={DeleteCoupon}
              variant="contained"
              sx={{
                backgroundColor: Color.color6,
                "&:hover": { backgroundColor: Color.color6 },
              }}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Popover>
    </>
  );
}
